module.exports = __webpack_public_path__ + "img/DSC_0008.2344444e.jpg";